import itemsAvailabilityByUniqKey from './itemsAvailabilityByUniqKey';

export default {
  itemsAvailabilityByUniqKey
};
